var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9987 4.58325C10.7556 4.58325 10.5224 4.67983 10.3505 4.85174C10.1786 5.02365 10.082 5.2568 10.082 5.49992V12.8333C10.082 13.0764 10.1786 13.3095 10.3505 13.4814C10.5224 13.6533 10.7556 13.7499 10.9987 13.7499C11.2418 13.7499 11.475 13.6533 11.6469 13.4814C11.8188 13.3095 11.9154 13.0764 11.9154 12.8333V5.49992C11.9154 5.2568 11.8188 5.02365 11.6469 4.85174C11.475 4.67983 11.2418 4.58325 10.9987 4.58325Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9154 16.4999C11.9154 15.9937 11.505 15.5833 10.9987 15.5833C10.4924 15.5833 10.082 15.9937 10.082 16.4999C10.082 17.0062 10.4924 17.4166 10.9987 17.4166C11.505 17.4166 11.9154 17.0062 11.9154 16.4999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.32b47c290aad6343f559995ce7a2c4ba.svg";
export { ForwardRef as ReactComponent };